module.exports = __webpack_public_path__ + "static/media/Frances_result.9f9f93b4.jpg";